import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * Componente que redirige usuarios autenticados a su área correspondiente
 * - Cliente → Catálogo
 * - Admin/Vendedor → Dashboard
 */
const ClientRedirect = ({ children }) => {
  const { isAuthenticated, isCliente, isAdmin, isVendedor, loading } = useAuth();

  if (loading) {
    return (
      <Box className="d-flex justify-center align-center min-h-screen">
        <CircularProgress />
      </Box>
    );
  }

  // Si está autenticado, redirigir según el rol
  if (isAuthenticated) {
    if (isCliente) {
      return <Navigate to="/catalog-client" replace />;
    }
    if (isAdmin || isVendedor) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Si no está autenticado, permitir acceso a páginas públicas
  return children;
};

export default ClientRedirect;

